mutation TravelPolicyDelete($input: TravelPolicyDeleteInput!) {
  travelPolicyDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
